import Banner from "../../assets/images/banner.png";
import DogbookBanner from "../../assets/images/dogbook/banner.png";
import MyPointBanner from "../../assets/images/my-point/banner.png";
import MyPointShopBanner from "../../assets/images/my-point-shop/banner.png";
import MemberInfo from "../../assets/images/haier-member.png";
import ShopInfo from "../../assets/images/haier-store.png";
import redeemGiftBanner from "../../assets/images/redeem-gift/banner.png";
import redeemGiftMemberBanner from "../../assets/images/redeem-gift/banner-member.png";
import quiz from "../../assets/images/quiz3.png";
import register from "../../assets/images/register-banner.png";
import luckyDraw from "../../assets/images/lucky-draw-banner.png";
import memberPrivilage from "../../assets/images/member-privilage.png";
import product from "../../assets/images/member-product.png";
import React from "react";

export default function TopBanner({ type , img}) {
  let bannerImage;
  switch (type) {
    case "dogbook":
      bannerImage = DogbookBanner;
      break;
    case "myPoint":
      bannerImage = MyPointBanner;
      break;
    case "memberInfo":
      bannerImage = MemberInfo;
      break;
    case 'shopInfo':
      bannerImage = ShopInfo;
      break;
    case 'redeemGift':
      bannerImage = redeemGiftBanner;
      break;
    case "redeemGiftMember":
      bannerImage = redeemGiftMemberBanner;
      break;
    case "myPointShop":
      bannerImage = MyPointShopBanner;
      break;
    case "quiz":
      bannerImage = quiz;
      break;
    case "register":
      bannerImage = register;
      break;
    case "luckyDraw":
      bannerImage = img;
      break;
    case "luckyDraw2":
      bannerImage = img;
      break;
    case "memberPrivilage":
      bannerImage = memberPrivilage;
      break;
    case "product":
      bannerImage = product;
      break;
    default:
      bannerImage = Banner;
  }
  return (
    <>
      <div className={type==='luckyDraw' ? 'text-center mx-[-20px]' : 'text-center'}>
        <img src={bannerImage} alt="logo" className="w-full" />
      </div>
    </>
  );
}
